import { StarIcon } from '@heroicons/react/solid';
import { useState } from 'react';

function Rate() {
    const [rating, setRating] = useState(0);

    return (
        <div className="flex">
            {rating > 0 && <input type="hidden" name="rating" value={rating} />}
            {Array(5)
                .fill(0)
                .map((_, index) => (
                    <div
                        key={index}
                        className={`cursor-pointer ${rating >= index + 0.5 ? 'text-yellow-400' : 'text-gray-300'}`}
                        onClick={() => {
                            setRating(index + 1);
                        }}
                    >
                        <StarIcon className="w-8" />
                    </div>
                ))}
        </div>
    );
}

export default Rate;
